/**
 * quote products using spree quote services,
 * remember configure automatic_quote-config
 */
import axios from 'axios'

const base = () => axios.create({
  baseURL: Spree.routes.product_quote_url,
})

export const doQuote = async (
  parameters,
  token,
  variant,
  quoteNumber,
  bundle_number,
  bundle_variant_id,
) => {
  const body = {
    parameters,
    authenticity_token: token,
    variant_id: variant,
    bundle_number,
    bundle_variant_id,
  }

  // eslint-disable-next-line no-useless-catch
  try {
    if (quoteNumber && quoteNumber !== '') {
      return (await base().post(quoteNumber, body)).data; // requote
    }

    return (await base().post('', body)).data; // new quote
  } catch (err) {
    throw err
  }
}

export const doQuotePriceSelected = async (data, token, quoteNumber) => {
  const body = {
    authenticity_token: token,
    method: 'price_selected',
    quote_update: data,
  }

  return (await base().post(`${quoteNumber}/update`, body)).data
}
